import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Legalpage.css';

const SECTIONS = [
  { id: 'objet',          num: '01', label: 'Objet' },
  { id: 'prestations',    num: '02', label: 'Prestations' },
  { id: 'devis',          num: '03', label: 'Devis & commande' },
  { id: 'tarifs',         num: '04', label: 'Tarifs & paiement' },
  { id: 'execution',      num: '05', label: 'Exécution' },
  { id: 'garanties',      num: '06', label: 'Garanties' },
  { id: 'responsabilite', num: '07', label: 'Responsabilité' },
  { id: 'resiliation',    num: '08', label: 'Résiliation' },
  { id: 'litiges',        num: '09', label: 'Litiges' },
  { id: 'divers',         num: '10', label: 'Dispositions diverses' },
];

export default function Cgv() {
  const navigate = useNavigate();
  return (
    <>
      <Navbar />
      <div className="legal">

        <div className="legal__hero">
          <div className="legal__hero-inner container">
            <button className="legal__back" onClick={() => navigate(-1)} type="button">
              <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M19 12H5M12 5l-7 7 7 7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Retour
            </button>
            <h1 className="legal__title">Conditions Générales de Vente</h1>
            <p className="legal__subtitle">En vigueur au 25 mars 2026 · SOCLIMATE SAS</p>
          </div>
        </div>

        <div className="legal__body">
          <div className="container">
            <div className="legal__grid">

              <aside className="legal__toc">
                <p className="legal__toc-title">Sommaire</p>
                <ul className="legal__toc-list">
                  {SECTIONS.map(s => (
                    <li key={s.id}>
                      <a href={`#${s.id}`} className="legal__toc-link">{s.label}</a>
                    </li>
                  ))}
                </ul>
              </aside>

              <main className="legal__content">

                <div className="legal__info-box" style={{ marginBottom: '2.5rem' }}>
                  <p>Les présentes Conditions Générales de Vente (CGV) régissent l'ensemble des relations contractuelles entre SOCLIMATE et ses clients, particuliers ou professionnels, pour toute prestation de services réalisée par la société.</p>
                </div>

                <section id="objet" className="legal__section">
                  <span className="legal__section-num">01</span>
                  <h2 className="legal__section-title">Objet</h2>
                  <p>Les présentes CGV ont pour objet de définir les droits et obligations des parties dans le cadre de la vente de prestations proposées par SOCLIMATE, SAS immatriculée sous le SIRET 991 881 194 00013, dont le siège social est situé 1 rue de Belloy, 95570 Villaines-sous-Bois.</p>
                  <p>Toute commande passée auprès de SOCLIMATE implique l'acceptation pleine et entière des présentes CGV, qui prévalent sur tout autre document du client.</p>
                </section>

                <section id="prestations" className="legal__section">
                  <span className="legal__section-num">02</span>
                  <h2 className="legal__section-title">Prestations proposées</h2>
                  <p>SOCLIMATE propose les prestations suivantes, sur la zone Île-de-France :</p>
                  <ul>
                    <li>Installation et mise en service de systèmes de climatisation (mono-split, multi-split, gainable) ;</li>
                    <li>Installation de pompes à chaleur air/air et air/eau ;</li>
                    <li>Installation et maintenance de systèmes de ventilation (VMC simple et double flux) ;</li>
                    <li>Entretien annuel et contrats de maintenance ;</li>
                    <li>Dépannage et réparation de systèmes existants ;</li>
                    <li>Conseil et étude technique préalable.</li>
                  </ul>
                  <p>SOCLIMATE est certifiée RGE QualiPAC, habilitant ses clients éligibles à bénéficier des aides de l'État (MaPrimeRénov', CEE, etc.).</p>
                </section>

                <section id="devis" className="legal__section">
                  <span className="legal__section-num">03</span>
                  <h2 className="legal__section-title">Devis et formation du contrat</h2>
                  <p>Toute prestation fait l'objet d'un devis préalable, établi gratuitement. Le devis précise notamment :</p>
                  <ul>
                    <li>La nature détaillée des travaux à réaliser ;</li>
                    <li>Le matériel fourni et ses caractéristiques techniques ;</li>
                    <li>Le prix TTC des prestations et fournitures ;</li>
                    <li>Le délai d'intervention prévisionnel ;</li>
                    <li>La durée de validité du devis (30 jours sauf mention contraire).</li>
                  </ul>
                  <p>Le contrat est formé à la réception par SOCLIMATE du devis signé, accompagné de l'acompte prévu le cas échéant.</p>
                  <div className="legal__info-box">
                    <p>Conformément à l'article L.221-18 du Code de la consommation, les clients particuliers disposent d'un <strong style={{ color: 'rgba(255,255,255,0.78)' }}>délai de rétractation de 14 jours</strong> à compter de la signature du devis, sauf si les travaux ont débuté avec leur accord exprès avant l'expiration de ce délai.</p>
                  </div>
                </section>

                <section id="tarifs" className="legal__section">
                  <span className="legal__section-num">04</span>
                  <h2 className="legal__section-title">Tarifs et modalités de paiement</h2>
                  <p>Les prix sont exprimés en euros TTC (TVA applicable selon la nature des travaux : 5,5 %, 10 % ou 20 %).</p>
                  <p><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Modalités de paiement :</strong></p>
                  <ul>
                    <li>Acompte de 30 % à la signature du devis pour toute prestation supérieure à 500 € TTC ;</li>
                    <li>Solde payable à la réception des travaux, sur présentation de la facture ;</li>
                    <li>Modes acceptés : virement bancaire, chèque, espèces (dans la limite légale de 1 000 €).</li>
                  </ul>
                  <p>En cas de retard de paiement, des pénalités seront appliquées au taux légal majoré de 3 points, dès le lendemain de l'échéance, sans mise en demeure préalable. Une indemnité forfaitaire de 40 € pour frais de recouvrement sera également due.</p>
                </section>

                <section id="execution" className="legal__section">
                  <span className="legal__section-num">05</span>
                  <h2 className="legal__section-title">Exécution des prestations</h2>
                  <p>SOCLIMATE s'engage à réaliser les prestations dans les règles de l'art, conformément aux normes en vigueur (DTU, NF C 15-100, réglementation F-Gaz).</p>
                  <p><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Obligations du client :</strong></p>
                  <ul>
                    <li>Permettre l'accès au chantier aux dates convenues ;</li>
                    <li>Assurer les conditions de sécurité nécessaires ;</li>
                    <li>Fournir un accès aux alimentations électriques et fluides ;</li>
                    <li>Signaler toute contrainte particulière (amiante, plomb, etc.) préalablement.</li>
                  </ul>
                  <p>Les délais indiqués sont indicatifs. SOCLIMATE ne saurait être tenue responsable des retards dus à des événements indépendants de sa volonté.</p>
                </section>

                <section id="garanties" className="legal__section">
                  <span className="legal__section-num">06</span>
                  <h2 className="legal__section-title">Garanties</h2>
                  <ul>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Garantie de parfait achèvement</strong> (art. 1792-6 C. civ.) — 1 an à compter de la réception des travaux ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Garantie biennale</strong> (art. 1792-3 C. civ.) — 2 ans sur les équipements dissociables de l'ouvrage ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Garantie décennale</strong> (art. 1792 C. civ.) — 10 ans pour les dommages compromettant la solidité de l'ouvrage ;</li>
                    <li><strong style={{ color: 'rgba(255,255,255,0.72)' }}>Garantie fabricant</strong> — variable selon les équipements, reportée sur le client à la mise en service.</li>
                  </ul>
                </section>

                <section id="responsabilite" className="legal__section">
                  <span className="legal__section-num">07</span>
                  <h2 className="legal__section-title">Responsabilité</h2>
                  <p>SOCLIMATE est couverte par une assurance responsabilité civile professionnelle et décennale. Sa responsabilité ne saurait être engagée pour :</p>
                  <ul>
                    <li>Les dommages résultant d'un usage anormal des installations ;</li>
                    <li>Les dommages causés par des modifications effectuées par un tiers non agréé ;</li>
                    <li>Les conséquences d'un défaut d'entretien imputable au client ;</li>
                    <li>Les cas de force majeure (art. 1218 du Code civil).</li>
                  </ul>
                  <p>En tout état de cause, la responsabilité de SOCLIMATE est limitée au montant de la prestation à l'origine du préjudice.</p>
                </section>

                <section id="resiliation" className="legal__section">
                  <span className="legal__section-num">08</span>
                  <h2 className="legal__section-title">Résiliation et annulation</h2>
                  <p>Toute annulation après acceptation du devis doit être notifiée par écrit. Les conditions suivantes s'appliquent :</p>
                  <ul>
                    <li>Annulation avant le début des travaux : l'acompte versé reste acquis à SOCLIMATE à titre d'indemnité ;</li>
                    <li>Annulation en cours d'exécution : facturation au prorata des travaux réalisés et matériaux commandés, majorée de 15 % ;</li>
                    <li>Droit de rétractation légal (particuliers) : remboursement intégral de l'acompte sous 14 jours.</li>
                  </ul>
                </section>

                <section id="litiges" className="legal__section">
                  <span className="legal__section-num">09</span>
                  <h2 className="legal__section-title">Règlement des litiges</h2>
                  <p>En cas de litige, les parties s'engagent à rechercher une solution amiable. Toute réclamation doit être adressée à SOCLIMATE, 1 rue de Belloy, 95570 Villaines-sous-Bois, ou à contact@soclimate.fr.</p>
                  <div className="legal__info-box">
                    <p>Conformément aux articles L.611-1 et suivants du Code de la consommation, les particuliers peuvent recourir gratuitement à un médiateur. SOCLIMATE adhère au dispositif : <strong style={{ color: 'rgba(255,255,255,0.78)' }}>CM2C — www.cm2c.net</strong></p>
                  </div>
                  <p>À défaut de résolution amiable, les tribunaux compétents dans le ressort du siège social de SOCLIMATE seront seuls compétents.</p>
                </section>

                <section id="divers" className="legal__section">
                  <span className="legal__section-num">10</span>
                  <h2 className="legal__section-title">Dispositions diverses</h2>
                  <p>Les présentes CGV sont soumises au droit français. Si l'une des clauses était déclarée nulle, les autres clauses demeureraient pleinement applicables.</p>
                  <table className="legal__table" style={{ marginTop: '1rem' }}>
                    <tbody>
                      <tr><th>Société</th><td>SOCLIMATE SAS</td></tr>
                      <tr><th>SIRET</th><td>991 881 194 00013</td></tr>
                      <tr><th>N° TVA</th><td>FR08991881194</td></tr>
                      <tr><th>Siège social</th><td>1 rue de Belloy, 95570 Villaines-sous-Bois</td></tr>
                      <tr><th>Version en vigueur</th><td>25 mars 2026</td></tr>
                    </tbody>
                  </table>
                </section>

              </main>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}